// extracted by mini-css-extract-plugin
export default {"image":"ExpertiseSection_image__Cv0lC","contentDiv":"ExpertiseSection_contentDiv__Zi94d","imageDiv":"ExpertiseSection_imageDiv__6rl-d","list":"ExpertiseSection_list__NeyNS"};